import { useEffect, useRef, useState } from 'react';

import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { MethodsService } from 'shared/services/methods.service';
import { TCompare } from 'shared/services/types/compare.types';

export const useGetCompare = (data: TCompare.GetCompare) => {
  const prevDataRef = useRef<TCompare.GetCompare | null>(data);
  const [isUserLoading, setIsUserLoading] = useState(false);

  useEffect(() => {
    const stringPrev = JSON.stringify(prevDataRef.current);
    const stringCurrent = JSON.stringify(data);

    const wasInitialized = stringPrev !== stringCurrent;

    if (wasInitialized) {
      setIsUserLoading(true);
    } else {
      setIsUserLoading(false);
    }

    prevDataRef.current = data;
  }, [JSON.stringify(data)]);

  const {
    isLoading: isCompareLoading,
    data: compare,
    isError: isCompareError,
    isFetching: isFetchingFromQuery,
    ...restData
  } = useQuery({
    queryFn: () => MethodsService.getCompare(data),
    queryKey: ['get compare table', data],
    retry: 0,
    select: ({ data }) => data,
    refetchInterval: 30000,
    placeholderData: keepPreviousData
  });

  useEffect(() => {
    if (!isFetchingFromQuery) {
      setIsUserLoading(false);
    }
  }, [isFetchingFromQuery]);

  const isCompareFetching = isFetchingFromQuery && isUserLoading;

  return { isCompareLoading, compare, isCompareError, isCompareFetching, ...restData };
};
